<template>
    <div class="item-hotel" v-if="hotel && isCheckIn">
        <ul>
            <li>
                <div class="has-icon moon-icon d-flex justify-content-between">
                    <div>
                        <p>{{hotelName}}</p>
                    </div>
                    <div class="tools">
                        <button class="btn info" @click="onClickInfo">
                            <div></div>
                        </button>
                    </div>
                </div>
                <div class="info">
                    <p class="font-weight-normal">check-in <b>{{nights}}</b> {{nights === 1 ? 'Notte' : 'Notti'}}</p>
                </div>
                <div class="add-transfer">
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {daysBetweenPeriod, hotelName, isSameDate} from '../../../../utils/helper'

export default {
  name: 'ItemHotelCheckIn',
  props: {
    day: {
      type: Date,
      default: new Date()
    },
    days: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    hotel () {
      const list = this.$store.getters.getSelectedHotelsByDay(this.day)
      if (!list) return null
      return list.find(item => {
        return isSameDate(this.day, item.period.start)
      })
    },
    hotelName () {
      return hotelName(this.hotel.hotel.location.name)
    },
    nights () {
      return daysBetweenPeriod(this.hotel.period)
    },
    isCheckIn () {
      return isSameDate(this.day, this.hotel.period.start)
    }
  },
  methods: {
    ...mapGetters(['getSelectedHotels']),
    onClickInfo () {
      this.$emit('detail', this.hotel)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemHotelCheckIn.vue